import { render } from "./CuentasPorCobrar.vue?vue&type=template&id=255758d5&scoped=true"
import script from "./CuentasPorCobrar.vue?vue&type=script&lang=js"
export * from "./CuentasPorCobrar.vue?vue&type=script&lang=js"

import "./CuentasPorCobrar.vue?vue&type=style&index=0&id=255758d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-255758d5"]])

export default __exports__